const DAY_MS = 86_400_000;

/**
 * Whole days until the trial ends, for "Trial · N days left" copy.
 * Ceils so a trial ending later today still reads "1 day left" — "0 days
 * left" while sending still works reads as already over. Returns null with
 * no deadline, 0 once the deadline has passed.
 */
export function trialDaysLeft(
    trialEndsAt: string | null | undefined,
    now = new Date(),
): number | null {
    if (!trialEndsAt) return null;
    const ends = Date.parse(trialEndsAt);
    if (Number.isNaN(ends)) return null;
    return Math.max(0, Math.ceil((ends - now.getTime()) / DAY_MS));
}
